import { FC, useMemo } from "react";
import { Button, Stack, Text } from "@chakra-ui/react";

import { SchedulePaymentOptionCodeType } from "./PaymentBlockOptions.tsx";
import { isStringWithNumber, formatPriceWithoutZeros } from "../../../../../utils";

interface Props {
  code: SchedulePaymentOptionCodeType;
  title: string;
  amount: string | undefined;
  isSelected: boolean;
  onClick: () => void;
}

export const PaymentBlockOptionItem: FC<Props> = (props) => {
  const {
    code,
    title,
    amount,
    isSelected,
    onClick,
  } = props;

  const formattedAmount = isStringWithNumber(amount) && Number(amount) > 0
    ? formatPriceWithoutZeros(Number(amount))
    : "";

  const { colorScheme, bg, textVariant } = useMemo(() => {
    let colorScheme: "gray" | "red" | "brand" = "gray";
    let bg = "gray.50";
    let textVariant: "gray" | "white" = "gray";

    if (isSelected) {
      const isOverdue = code === "overdue";

      colorScheme = isOverdue ? "red" : "brand";
      bg = isOverdue ? "red.500" : "brand.500";
      textVariant = "white";
    }

    return { colorScheme, bg, textVariant } as const;
  }, [isSelected]);

  if (!formattedAmount) {
    return null;
  }

  return (
    <Button
      h="32px"
      w="100px"
      px="6px"
      borderRadius="8px"
      justifyContent="flex-start"
      colorScheme={colorScheme}
      bg={bg}
      onClick={onClick}
      cursor={isSelected ? "default" : "pointer"}
      pointerEvents={isSelected ? "none" : "auto"}
    >
      <Stack spacing={0} alignItems="flex-start">
        <Text variant={textVariant} lineHeight="11px" fontSize="9px">{title}</Text>
        <Text variant={textVariant} lineHeight="14px" fontSize="10px">{formattedAmount}</Text>
      </Stack>
    </Button>
  );
};
